import * as Types from '../gql/types2';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {"context":{"clientName":"graphql2"}} as const;
export type MarkReadNotificationMutationVariables = Types.Exact<{
  input: Types.MarkReadCommand;
}>;


export type MarkReadNotificationMutation = { __typename?: 'MutationModel', notifications: { __typename?: 'AppNotificationMutationModel', markRead: { __typename?: 'ValidationResponse', errors: Array<{ __typename?: 'ValidationError', message: string, argumentName?: string | null }> } } };


export const MarkReadNotificationDocument = gql`
    mutation MarkReadNotification($input: MarkReadCommand!) {
  notifications {
    markRead(input: $input) {
      errors {
        message
        argumentName
      }
    }
  }
}
    `;
export type MarkReadNotificationMutationFn = Apollo.MutationFunction<MarkReadNotificationMutation, MarkReadNotificationMutationVariables>;

/**
 * __useMarkReadNotificationMutation__
 *
 * To run a mutation, you first call `useMarkReadNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkReadNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markReadNotificationMutation, { data, loading, error }] = useMarkReadNotificationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMarkReadNotificationMutation(baseOptions?: Apollo.MutationHookOptions<MarkReadNotificationMutation, MarkReadNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkReadNotificationMutation, MarkReadNotificationMutationVariables>(MarkReadNotificationDocument, options);
      }
export type MarkReadNotificationMutationHookResult = ReturnType<typeof useMarkReadNotificationMutation>;
export type MarkReadNotificationMutationResult = Apollo.MutationResult<MarkReadNotificationMutation>;
export type MarkReadNotificationMutationOptions = Apollo.BaseMutationOptions<MarkReadNotificationMutation, MarkReadNotificationMutationVariables>;